import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  StyledAssistantTypography,
  StyledBox,
  StyledBoxButton,
  StyledBoxCard,
  StyledBoxStart,
  StyledBoxUpload,
  StyledBoxWrapperButton,
  StyledDivider,
  StyledFormControlLabel,
  StyledGrid,
  StyledInputAdornment,
  StyledInputGrid,
  StyledMain,
  StyledTypographyEnter,
  StyledTypographyOrder,
  StyledTypographyProduct,
  StyledTypographyRup,
} from "./style";
import { Box, Checkbox, Divider, InputAdornment } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FieldArray, Form, Formik } from "formik";
import CustomInput from "../../common/input/CustomInput";
import CustomButton from "../../common/button/CustomButton";
import theme from "../../../theme";
import * as Yup from "yup";
import CustomDropdown from "../../common/common-dropdown/CustomDropdown";
import imgIcon from "../../../assets/images/image-add.png";

import { StyledInput } from "../../../pages/profile/style";
import AddRound from "../../../assets/Icons/AddRound";
import { useDispatch } from "react-redux";
import {
  VIRTUAL_LOCKER_ADD_ITEM,
  VIRTUAL_LOCKER_GET_ITEM,
} from "../../../actions/VirtualLockerAction";
import {
  arrOptionSize,
  selfDropTimeOptions,
  videoOption,
} from "./constant";
import { StyledBoxFlex } from "../success-virtual-locker/style";
import { StyledTypography } from "../manual-split-calculation/style";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import { UPLOAD } from "../../../actions/AuthActions";
import { minimumTodayDateValidation } from "../../../utils/common";
import { getPhoneValidation } from "../../../utils/countryRules";

const selfDropItems = [
  {
    product_url: "",
    product_name: "",
    quantity: "",
    size: "",
    price: "",
    contains_liquid: false,
    estimated_delivery: "",
    additional_comments: "",
    order_type: "self_drop",
    product_image: [],
    shopping_with_video_call: "",
    preferred_date: "",
    preferred_time: "",
    shop_address: "",
    length: "",
    height: "",
    width: "",
    shop_landmark: "",
    weight: "",
  },
];
const personalShopperItems = [
  {
    order_type: "personal_shopper",
    product_name: "",
    quantity: null,
    additional_comments: "",
    contains_liquid: true,
    live_call: true,
    pickup_date: "",
    pickup_address: "",
    pickup_landmark: "",
    contact_person: "",
    contact_mobile: "",
  },
];
const shoppingItems = [
  {
    order_type: "online_shopping",
    product_name: "",
    quantity: "",
    price: "",
    additional_comments: "",
    shopping_with_video_call: "",
    preferred_date: "",
    preferred_time: "",
    shop_address: "",
    shop_landmark: "",
    product_description: "",
    status: "",
  },
];
export default function ProductDetails({ open, handleClose }) {
  const dispatch = useDispatch();
  const [active, setActive] = React.useState("self_drop");
  const [currentCountryCode, setCurrentCountryCode] = React.useState("+91");
  const fileInputRef = React.useRef();

  const getValidationSchema = React.useCallback((values = {}) => {
    const fieldType = values.fieldType;

    switch (fieldType) {
      case "self_drop":
        return Yup.object().shape({
          items: Yup.array()
            .of(
              Yup.object().shape({
                product_url: Yup.string()
                  .url("Enter a valid URL")
                  .required("Product URL is required"),
                product_name: Yup.string().required("Product Name is required"),
                preferred_time: Yup.string().required("Time is required"),
                shop_address: Yup.string().required("Address is required"),
                shop_landmark: Yup.string().required("Landmark is required"),
                estimated_delivery: Yup.string().when([], {
                  then: (schema) =>
                    schema.required("estimated delivery is required"),
                  otherwise: (schema) => schema.notRequired(),
                }),
                preferred_date: Yup.string().when([], {
                  then: (schema) =>
                    schema.required("Preferred date is required"),
                  otherwise: (schema) => schema.notRequired(),
                }),
                shopping_with_video_call: Yup.string().required(
                  "Select video call option"
                ),
                contains_liquid: Yup.boolean(),
                quantity: Yup.number()
                  // .max(5, "max product")
                  .required("Quantity is required"),
                price: Yup.number()
                  .typeError("Price must be a number")
                  .min(0, "Price cannot be negative")
                  .required("Price is required"),
              })
            )
            .min(1, "At least one item is required"),
        });

      case "personal_shopper":
        return Yup.object().shape({
          items: Yup.array()
            .of(
              Yup.object().shape({
                product_name: Yup.string().required("Product Name is required"),
                contact_person: Yup.string().required(
                  "Contact Person Name is required"
                ),
                pickup_date: Yup.string().required("Pickup date is required"),
                live_call: Yup.string().required("Select video call option"),
                pickup_address: Yup.string().required(
                  "Pickup Address is required"
                ),
                pickup_landmark: Yup.string().required("Landmark is required"),
                contact_mobile: Yup.string()
                  .required("Phone number is required")
                  .test(getPhoneValidation(currentCountryCode)),
                contains_liquid: Yup.boolean(),
                quantity: Yup.number()
                  // .max(5, "max product")
                  .required("Quantity is required"),
              })
            )
            .min(1, "At least one item is required"),
        });

      case "online_shopping":
        return Yup.object().shape({
          items: Yup.array()
            .of(
              Yup.object().shape({
                product_name: Yup.string().required("Product Name is required"),
                preferred_time: Yup.string().required("Time is required"),
                shop_address: Yup.string().required("Address is required"),
                shop_landmark: Yup.string().required("Landmark is required"),
                preferred_date: Yup.string().required(
                  "Preferred date is required"
                ),
                shopping_with_video_call: Yup.string().required(
                  "Select video call option"
                ),
                contains_liquid: Yup.boolean(),
                quantity: Yup.number()
                  // .max(5, "max product")
                  .required("Quantity is required"),
                price: Yup.number()
                  .typeError("Price must be a number")
                  .min(0, "Price cannot be negative")
                  .required("Price is required"),
              })
            )
            .min(1, "At least one item is required"),
        });

      default:
        return Yup.object().shape({});
    }
  }, [currentCountryCode]);

  const [validationSchema, setValidationSchema] = React.useState(
    () => getValidationSchema({ fieldType: "self_drop" }) // default initial schema
  );

  React.useEffect(() => {
    setValidationSchema(getValidationSchema({ fieldType: active }));
  }, [active, getValidationSchema]);
  const getItemLocker = React.useCallback(
    (values) => {
      dispatch({
        type: VIRTUAL_LOCKER_GET_ITEM,
        payload: values,
      });
    },
    [dispatch]
  );

  const handleUpload = async () => {
    fileInputRef.current.click();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <StyledBoxCard>
          <StyledBoxFlex>
            <StyledTypography>Tell Us About the Product</StyledTypography>
          </StyledBoxFlex>
          <CrossIcon color={theme.palette.custom.white} onClick={handleClose} />
        </StyledBoxCard>

        <Formik
          initialValues={{
            fieldType: "self_drop",
            items: selfDropItems,
          }}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            dispatch({
              type: VIRTUAL_LOCKER_ADD_ITEM,
              payload: {
                // ...values,
                items: values.items,
                onSuccess: () => {
                  handleClose();
                  getItemLocker();
                },
              },
            });
          }}
        >
          {({
            errors,
            handleChange,
            handleBlur,
            values,
            touched,
            setFieldValue,
            handleSubmit,
          }) => (
            <Form>
              <Box>
                <StyledMain>
                  <StyledTypographyOrder>Order Type</StyledTypographyOrder>
                  <Grid container columnSpacing={2} rowSpacing={2}>
                    <StyledGrid
                      isactive={active === "self_drop"}
                      size={{ md: 4, sm: 12, xs: 12 }}
                      onClick={() => {
                        setActive("self_drop");
                        setFieldValue("items", selfDropItems);
                        setFieldValue("fieldType", "self_drop");
                      }}
                    >
                      Self Drop
                    </StyledGrid>
                    <StyledGrid
                      isactive={active === "personal_shopper"}
                      size={{ md: 4, sm: 12, xs: 12 }}
                      onClick={() => {
                        setActive("personal_shopper");
                        setFieldValue("items", personalShopperItems);
                        setFieldValue("fieldType", "personal_shopper");
                      }}
                    >
                      Personal
                      <br /> Shopper
                    </StyledGrid>
                    <StyledGrid
                      isactive={active === "online_shopping"}
                      size={{ md: 4, sm: 12, xs: 12 }}
                      onClick={() => {
                        setActive("online_shopping");
                        setFieldValue("items", shoppingItems);
                        setFieldValue("fieldType", "online_shopping");
                      }}
                    >
                      Online <br /> Shopping
                    </StyledGrid>
                  </Grid>
                </StyledMain>
              </Box>
              <FieldArray name="items">
                {({ push }) => (
                  <StyledMain>
                    {values?.items?.map((data, ind) => {
                      return (
                        <React.Fragment key={ind}>
                          <Box>
                            <Box>
                              <>
                                {active === "self_drop" && (
                                  <Box>
                                    <Grid container columnSpacing={2}>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          required
                                          customLabel="Product URL"
                                          placeholder="https://amazon_bamboo_comb/"
                                          name={`items[${ind}].product_url`}
                                          value={data.product_url}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched?.items?.[ind]
                                              ?.product_url &&
                                            Boolean(
                                              errors?.items?.[ind]?.product_url
                                            )
                                          }
                                          helperText={
                                            touched?.items?.[ind]
                                              ?.product_url &&
                                            errors?.items?.[ind]?.product_url
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          required
                                          customLabel="Product Name"
                                          placeholder="Bamboo Comb"
                                          name={`items[${ind}].product_name`}
                                          value={data.product_name}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched.items?.[ind]
                                              ?.product_name &&
                                            Boolean(
                                              errors.items?.[ind]?.product_name
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]
                                              ?.product_name &&
                                            errors.items?.[ind]?.product_name
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <StyledFormControlLabel
                                          control={
                                            <Checkbox
                                              checked={data.contains_liquid}
                                              onChange={(e) =>
                                                setFieldValue(
                                                  `items[${ind}].contains_liquid`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          }
                                          label="Contains liquid or semi-liquid item"
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          required
                                          label="Quantity"
                                          type="number"
                                          name={`items[${ind}].quantity`}
                                          value={data.quantity}
                                          onBlur={handleBlur}
                                          onChange={(e) => setFieldValue(`items[${ind}].quantity`, e.target.value)}
                                          error={
                                            touched.items?.[ind]?.quantity &&
                                            Boolean(
                                              errors.items?.[ind]?.quantity
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]?.quantity &&
                                            errors.items?.[ind]?.quantity
                                          }
                                          inputProps={{ min: 1 }}
                                        />
                                      </Grid>
                                      <Grid
                                        size={{ lg: 6, md: 6, sm: 12, xs: 12 }}
                                      >
                                        <CustomDropdown
                                          options={arrOptionSize}
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          customLabel="Size"
                                          name={`items[${ind}].size`}
                                          value={data.size}
                                          onBlur={handleBlur}
                                          setFieldValue={setFieldValue}
                                          error={
                                            touched.items?.[ind]?.size &&
                                            Boolean(errors.items?.[ind]?.size)
                                          }
                                          helperText={
                                            touched.items?.[ind]?.size &&
                                            errors.items?.[ind]?.size
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 6,
                                          md: 6,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          endAdornment={
                                            <InputAdornment position="end">
                                              Kg
                                            </InputAdornment>
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          customLabel="Approximate Weight"
                                          height="10px"
                                          type="number"
                                          placeholder="Weight"
                                          name={`items[${ind}].weight`}
                                          value={data.weight}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                      </Grid>
                                      {/* if need new design wise */}
                                      <Grid
                                        size={{ lg: 4, md: 4, sm: 12, xs: 12 }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          endAdornment={
                                            <InputAdornment position="end">
                                              cm
                                            </InputAdornment>
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          customLabel="Dimensions"
                                          type="number"
                                          placeholder="Length"
                                          name={`items[${ind}].length`}
                                          value={data.length}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                      </Grid>

                                      <StyledInputGrid
                                        size={{ lg: 8, md: 8, sm: 12, xs: 12 }}
                                      >
                                        <Grid
                                          size={{
                                            lg: 6,
                                            md: 6,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomInput
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            endAdornment={
                                              <InputAdornment position="end">
                                                cm
                                              </InputAdornment>
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            type="number"
                                            customLabel=""
                                            placeholder="Width"
                                            name={`items[${ind}].width`}
                                            value={data.width}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                        </Grid>
                                        <Grid
                                          size={{
                                            lg: 6,
                                            md: 6,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomInput
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            endAdornment={
                                              <InputAdornment position="end">
                                                cm
                                              </InputAdornment>
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            type="number"
                                            placeholder="Height"
                                            name={`items[${ind}].height`}
                                            value={data.height}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                        </Grid>
                                      </StyledInputGrid>

                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          type="number"
                                          required
                                          startAdornment={
                                            <StyledBoxStart>
                                              <StyledInputAdornment position="start">
                                                <StyledTypographyRup>
                                                  ₹
                                                </StyledTypographyRup>
                                              </StyledInputAdornment>
                                            </StyledBoxStart>
                                          }
                                          isDollar="true"
                                          customLabel="Price"
                                          placeholder="0.00"
                                          name={`items[${ind}].price`}
                                          value={data.price}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched.items?.[ind]?.price &&
                                            Boolean(errors.items?.[ind]?.price)
                                          }
                                          helperText={
                                            touched.items?.[ind]?.price &&
                                            errors.items?.[ind]?.price
                                          }
                                        />
                                      </Grid>
                                    </Grid>
                                    <Box>
                                      <StyledTypographyEnter>
                                        Enter price (inclusive of delivery
                                        charges)
                                      </StyledTypographyEnter>
                                    </Box>
                                    <Box>
                                      <StyledTypographyOrder>
                                        Product Image
                                      </StyledTypographyOrder>
                                      <StyledBoxUpload>
                                        {values.items?.[ind]?.product_image.map(productSingleImage => (
                                          <img
                                            src={productSingleImage ? productSingleImage : imgIcon}
                                            alt="imgIcon"
                                            loading="lazy"
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                            }}
                                          />
                                        ))}
                                        <StyledTypographyProduct
                                          onClick={handleUpload}
                                        >
                                          Upload Product Image
                                        </StyledTypographyProduct>
                                        <StyledInput
                                          type="file"
                                          ref={fileInputRef}
                                          onChange={(e) => {
                                            const file = e.target.files[0];
                                            dispatch({
                                              type: UPLOAD,
                                              payload: file,
                                              onSuccess : (imageLink) => {
                                                setFieldValue(
                                                `items.[${ind}].product_image`,
                                                [...values.items?.[ind]?.product_image, imageLink]
                                              );
                                              }
                                            });
                                            
                                          }}
                                          accept="image/*"
                                        />
                                      </StyledBoxUpload>

                                      <Box>
                                        <Grid container columnSpacing={2}>
                                          <Grid
                                            size={{
                                              lg: 12,
                                              md: 12,
                                              sm: 12,
                                              xs: 12,
                                            }}
                                          >
                                            <CustomInput
                                              color={
                                                theme.palette.custom
                                                  .productTextColor
                                              }
                                              fontSize={
                                                theme.typography.regular
                                                  .fontSize
                                              }
                                              height="10px"
                                              required
                                              type="date"
                                              customLabel="Estimated Delivery"
                                              min={minimumTodayDateValidation()}
                                              name={`items[${ind}].estimated_delivery`}
                                              value={data.estimated_delivery}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              error={
                                                touched.items?.[ind]
                                                  ?.estimated_delivery &&
                                                Boolean(
                                                  errors.items?.[ind]
                                                    ?.estimated_delivery
                                                )
                                              }
                                              helperText={
                                                touched.items?.[ind]
                                                  ?.estimated_delivery &&
                                                errors.items?.[ind]
                                                  ?.estimated_delivery
                                              }
                                            />
                                          </Grid>
                                          <Grid
                                            size={{
                                              lg: 12,
                                              md: 12,
                                              sm: 12,
                                              xs: 12,
                                            }}
                                          >
                                            <CustomInput
                                              color={
                                                theme.palette.custom
                                                  .productTextColor
                                              }
                                              fontSize={
                                                theme.typography.regular
                                                  .fontSize
                                              }
                                              height="10px"
                                              customLabel="Additional Comments"
                                              name={`items[${ind}].additional_comments`}
                                              value={data.additional_comments}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              multiline
                                              rows={4}
                                              error={
                                                touched.items?.[ind]
                                                  ?.additional_comments &&
                                                Boolean(
                                                  errors.items?.[ind]
                                                    ?.additional_comments
                                                )
                                              }
                                              helperText={
                                                touched.items?.[ind]
                                                  ?.additional_comments &&
                                                errors.items?.[ind]
                                                  ?.additional_comments
                                              }
                                            />
                                          </Grid>
                                        </Grid>
                                        <Grid
                                          size={{
                                            lg: 12,
                                            md: 12,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomDropdown
                                            options={videoOption}
                                            required
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            customLabel="Shopping with Video call?"
                                            name={`items[${ind}].shopping_with_video_call`}
                                            value={
                                              data.shopping_with_video_call
                                            }
                                            onBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            error={
                                              touched.items?.[ind]
                                                ?.shopping_with_video_call &&
                                              Boolean(
                                                errors.items?.[ind]
                                                  ?.shopping_with_video_call
                                              )
                                            }
                                            helperText={
                                              touched.items?.[ind]
                                                ?.shopping_with_video_call &&
                                              errors.items?.[ind]
                                                ?.shopping_with_video_call
                                            }
                                          />
                                        </Grid>
                                        <Grid
                                          size={{
                                            lg: 6,
                                            md: 6,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomInput
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            required
                                            type="date"
                                            customLabel="Preferred Shopping Date"
                                            min={minimumTodayDateValidation()}
                                            name={`items[${ind}].preferred_date`}
                                            value={data.preferred_date}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={
                                              touched.items?.[ind]
                                                ?.preferred_date &&
                                              Boolean(
                                                errors.items?.[ind]
                                                  ?.preferred_date
                                              )
                                            }
                                            helperText={
                                              touched.items?.[ind]
                                                ?.preferred_date &&
                                              errors.items?.[ind]
                                                ?.preferred_date
                                            }
                                          />
                                        </Grid>
                                        <Grid
                                          size={{
                                            lg: 6,
                                            md: 6,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomDropdown
                                            options={selfDropTimeOptions}
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            customLabel="Time"
                                            name={`items[${ind}].preferred_time`}
                                            value={data.preferred_time}
                                            onBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            error={
                                              touched.items?.[ind]
                                                ?.preferred_time &&
                                              Boolean(
                                                errors.items?.[ind]
                                                  ?.preferred_time
                                              )
                                            }
                                            helperText={
                                              touched.items?.[ind]
                                                ?.preferred_time &&
                                              errors.items?.[ind]
                                                ?.preferred_time
                                            }
                                          />
                                        </Grid>
                                        <Grid
                                          size={{
                                            lg: 12,
                                            md: 12,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomInput
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            required
                                            customLabel="Shop Address"
                                            placeholder="Address"
                                            name={`items[${ind}].shop_address`}
                                            value={data.shop_address}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={
                                              touched?.items?.[ind]
                                                ?.shop_address &&
                                              Boolean(
                                                errors?.items?.[ind]
                                                  ?.shop_address
                                              )
                                            }
                                            helperText={
                                              touched?.items?.[ind]
                                                ?.shop_address &&
                                              errors?.items?.[ind]?.shop_address
                                            }
                                          />
                                        </Grid>
                                        <Grid
                                          size={{
                                            lg: 12,
                                            md: 12,
                                            sm: 12,
                                            xs: 12,
                                          }}
                                        >
                                          <CustomInput
                                            color={
                                              theme.palette.custom
                                                .productTextColor
                                            }
                                            fontSize={
                                              theme.typography.regular.fontSize
                                            }
                                            height="10px"
                                            required
                                            customLabel="Landmark"
                                            placeholder="Address"
                                            name={`items[${ind}].shop_landmark`}
                                            value={data.shop_landmark}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={
                                              touched?.items?.[ind]
                                                ?.shop_landmark &&
                                              Boolean(
                                                errors?.items?.[ind]
                                                  ?.shop_landmark
                                              )
                                            }
                                            helperText={
                                              touched?.items?.[ind]
                                                ?.shop_landmark &&
                                              errors?.items?.[ind]
                                                ?.shop_landmark
                                            }
                                          />
                                        </Grid>
                                      </Box>
                                    </Box>
                                  </Box>
                                )}
                                {active === "personal_shopper" && (
                                  <Grid container columnSpacing={2}>
                                    <Grid
                                      size={{
                                        lg: 12,
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <CustomInput
                                        color={
                                          theme.palette.custom.productTextColor
                                        }
                                        fontSize={
                                          theme.typography.regular.fontSize
                                        }
                                        height="10px"
                                        required
                                        customLabel="Product Name"
                                        placeholder="Bamboo Comb"
                                        name={`items[${ind}].product_name`}
                                        value={data.product_name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={
                                          touched.items?.[ind]?.product_name &&
                                          Boolean(
                                            errors.items?.[ind]?.product_name
                                          )
                                        }
                                        helperText={
                                          touched.items?.[ind]?.product_name &&
                                          errors.items?.[ind]?.product_name
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      size={{
                                        lg: 12,
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <StyledFormControlLabel
                                        control={
                                          <Checkbox
                                            checked={data.contains_liquid}
                                            onChange={(e) =>
                                              setFieldValue(
                                                `items[${ind}].contains_liquid`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        }
                                        label="Contains liquid or semi-liquid item"
                                      />
                                    </Grid>
                                    <Grid
                                      size={{ lg: 6, md: 6, sm: 12, xs: 12 }}
                                    >
                                      <CustomInput
                                        required
                                        label="Quantity"
                                        type="number"
                                        name={`items[${ind}].quantity`}
                                        value={data.quantity}
                                        onBlur={handleBlur}
                                        onChange={(e) => setFieldValue(`items[${ind}].quantity`, e.target.value)}
                                        error={
                                          touched.items?.[ind]?.quantity &&
                                          Boolean(errors.items?.[ind]?.quantity)
                                        }
                                        helperText={
                                          touched.items?.[ind]?.quantity &&
                                          errors.items?.[ind]?.quantity
                                        }
                                        inputProps={{ min: 1 }}
                                      />
                                    </Grid>
                                    <Grid
                                      size={{
                                        lg: 6,
                                        md: 6,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <CustomInput
                                        color={
                                          theme.palette.custom.productTextColor
                                        }
                                        fontSize={
                                          theme.typography.regular.fontSize
                                        }
                                        height="10px"
                                        required
                                        type="date"
                                        customLabel="Pickup Date"
                                        name={`items[${ind}].pickup_date`}
                                        min={minimumTodayDateValidation()}
                                        value={data.pickup_date}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={
                                          touched.items?.[ind]?.pickup_date &&
                                          Boolean(
                                            errors.items?.[ind]?.pickup_date
                                          )
                                        }
                                        helperText={
                                          touched.items?.[ind]?.pickup_date &&
                                          errors.items?.[ind]?.pickup_date
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      size={{
                                        lg: 12,
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <CustomInput
                                        color={
                                          theme.palette.custom.productTextColor
                                        }
                                        fontSize={
                                          theme.typography.regular.fontSize
                                        }
                                        height="10px"
                                        required
                                        customLabel="Pickup Address"
                                        placeholder="Address"
                                        name={`items[${ind}].pickup_address`}
                                        value={data.pickup_address}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={
                                          touched?.items?.[ind]
                                            ?.pickup_address &&
                                          Boolean(
                                            errors?.items?.[ind]?.pickup_address
                                          )
                                        }
                                        helperText={
                                          touched?.items?.[ind]
                                            ?.pickup_address &&
                                          errors?.items?.[ind]?.pickup_address
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      size={{
                                        lg: 12,
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <CustomInput
                                        color={
                                          theme.palette.custom.productTextColor
                                        }
                                        fontSize={
                                          theme.typography.regular.fontSize
                                        }
                                        height="10px"
                                        customLabel="Landmark"
                                        required
                                        placeholder="Landmark"
                                        name={`items[${ind}].pickup_landmark`}
                                        value={data.pickup_landmark}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={
                                          touched?.items?.[ind]
                                            ?.pickup_landmark &&
                                          Boolean(
                                            errors?.items?.[ind]
                                              ?.pickup_landmark
                                          )
                                        }
                                        helperText={
                                          touched?.items?.[ind]
                                            ?.pickup_landmark &&
                                          errors?.items?.[ind]?.pickup_landmark
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      size={{
                                        lg: 12,
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <StyledFormControlLabel
                                        control={
                                          <Checkbox
                                            checked={data.live_call}
                                            onChange={(e) =>
                                              setFieldValue(
                                                `items[${ind}].live_call`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        }
                                        label="With Live Call"
                                      />
                                      <StyledAssistantTypography>
                                        Connect with the Assigned Shopping
                                        Assistant with the chat
                                      </StyledAssistantTypography>
                                    </Grid>
                                    {/* <Grid
                                      size={{
                                        lg: 12,
                                        md: 12,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <StyledAssistantTypography>
                                        Connect with the Assigned Shopping
                                        Assistant with the chat
                                      </StyledAssistantTypography>
                                    </Grid> */}
                                    <Grid
                                      size={{
                                        lg: 6,
                                        md: 6,
                                        sm: 12,
                                        xs: 12,
                                      }}
                                    >
                                      <CustomInput
                                        color={
                                          theme.palette.custom.productTextColor
                                        }
                                        fontSize={
                                          theme.typography.regular.fontSize
                                        }
                                        height="10px"
                                        required
                                        customLabel="Contact Person's Name"
                                        placeholder="Name"
                                        name={`items[${ind}].contact_person`}
                                        value={data.contact_person}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={
                                          touched.items?.[ind]
                                            ?.contact_person &&
                                          Boolean(
                                            errors.items?.[ind]?.contact_person
                                          )
                                        }
                                        helperText={
                                          touched.items?.[ind]
                                            ?.contact_person &&
                                          errors.items?.[ind]?.contact_person
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      size={{ lg: 6, md: 6, sm: 12, xs: 12 }}
                                    >
                                      <CustomInput
                                        color={
                                          theme.palette.custom.productTextColor
                                        }
                                        fontSize={
                                          theme.typography.regular.fontSize
                                        }
                                        required
                                        height="10px"
                                        customLabel="Phone Number"
                                        type="text"
                                        name={`items[${ind}].contact_mobile`}
                                        value={data.contact_mobile}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isPhoneNumber={true}
                                        currentCountryCode={currentCountryCode}
                                        setCurrentCountryCode={
                                          setCurrentCountryCode
                                        }
                                        error={
                                          touched.items?.[ind]
                                            ?.contact_mobile &&
                                          Boolean(
                                            errors.items?.[ind]?.contact_mobile
                                          )
                                        }
                                        helperText={
                                          touched.items?.[ind]
                                            ?.contact_mobile &&
                                          errors.items?.[ind]?.contact_mobile
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                )}
                                {active === "online_shopping" && (
                                  <>
                                    <Grid container columnSpacing={2}>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          required
                                          customLabel="Product Name"
                                          placeholder="Bamboo Comb"
                                          name={`items[${ind}].product_name`}
                                          value={data.product_name}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched.items?.[ind]
                                              ?.product_name &&
                                            Boolean(
                                              errors.items?.[ind]?.product_name
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]
                                              ?.product_name &&
                                            errors.items?.[ind]?.product_name
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <StyledFormControlLabel
                                          control={
                                            <Checkbox
                                              checked={data.contains_liquid}
                                              onChange={(e) =>
                                                setFieldValue(
                                                  `items[${ind}].contains_liquid`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          }
                                          label="Contains liquid or semi-liquid item"
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          required
                                          label="Quantity"
                                          type="number"
                                          name={`items[${ind}].quantity`}
                                          value={data.quantity}
                                          onBlur={handleBlur}
                                          onChange={(e) => setFieldValue(`items[${ind}].quantity`, e.target.value)}
                                          error={
                                            touched.items?.[ind]?.quantity &&
                                            Boolean(
                                              errors.items?.[ind]?.quantity
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]?.quantity &&
                                            errors.items?.[ind]?.quantity
                                          }
                                          inputProps={{ min: 1 }}
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <StyledFormControlLabel
                                          control={
                                            <Checkbox
                                              checked={data.contains_liquid}
                                              onChange={(e) =>
                                                setFieldValue(
                                                  `items[${ind}].contains_liquid`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          }
                                          label="Allow Substitutions if items are unavailable?"
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          type="number"
                                          required
                                          startAdornment={
                                            <StyledBoxStart>
                                              <StyledInputAdornment position="start">
                                                <StyledTypographyRup>
                                                  ₹
                                                </StyledTypographyRup>
                                              </StyledInputAdornment>
                                            </StyledBoxStart>
                                          }
                                          isDollar="true"
                                          customLabel="Price"
                                          placeholder="0.00"
                                          name={`items[${ind}].price`}
                                          value={data.price}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched.items?.[ind]?.price &&
                                            Boolean(errors.items?.[ind]?.price)
                                          }
                                          helperText={
                                            touched.items?.[ind]?.price &&
                                            errors.items?.[ind]?.price
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          customLabel="Product Description"
                                          placeholder="Product Description"
                                          name={`items[${ind}].product_description`}
                                          value={data.product_description}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched.items?.[ind]
                                              ?.product_description &&
                                            Boolean(
                                              errors.items?.[ind]
                                                ?.product_description
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]
                                              ?.product_description &&
                                            errors.items?.[ind]
                                              ?.product_description
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomDropdown
                                          options={videoOption}
                                          required
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          customLabel="Shopping with Video call?"
                                          name={`items[${ind}].shopping_with_video_call`}
                                          value={data.shopping_with_video_call}
                                          onBlur={handleBlur}
                                          setFieldValue={setFieldValue}
                                          error={
                                            touched.items?.[ind]
                                              ?.shopping_with_video_call &&
                                            Boolean(
                                              errors.items?.[ind]
                                                ?.shopping_with_video_call
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]
                                              ?.shopping_with_video_call &&
                                            errors.items?.[ind]
                                              ?.shopping_with_video_call
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 6,
                                          md: 6,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          required
                                          type="date"
                                          customLabel="Preferred Shopping Date"
                                          name={`items[${ind}].preferred_date`}
                                          min={minimumTodayDateValidation()}
                                          value={data.preferred_date}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched.items?.[ind]
                                              ?.preferred_date &&
                                            Boolean(
                                              errors.items?.[ind]
                                                ?.preferred_date
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]
                                              ?.preferred_date &&
                                            errors.items?.[ind]?.preferred_date
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 6,
                                          md: 6,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomDropdown
                                          options={selfDropTimeOptions}
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          customLabel="Time"
                                          required
                                          name={`items[${ind}].preferred_time`}
                                          value={data.preferred_time}
                                          onBlur={handleBlur}
                                          setFieldValue={setFieldValue}
                                          error={
                                            touched.items?.[ind]
                                              ?.preferred_time &&
                                            Boolean(
                                              errors.items?.[ind]
                                                ?.preferred_time
                                            )
                                          }
                                          helperText={
                                            touched.items?.[ind]
                                              ?.preferred_time &&
                                            errors.items?.[ind]?.preferred_time
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          required
                                          customLabel="Shop Address"
                                          placeholder="Address"
                                          name={`items[${ind}].shop_address`}
                                          value={data.shop_address}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched?.items?.[ind]
                                              ?.shop_address &&
                                            Boolean(
                                              errors?.items?.[ind]?.shop_address
                                            )
                                          }
                                          helperText={
                                            touched?.items?.[ind]
                                              ?.shop_address &&
                                            errors?.items?.[ind]?.shop_address
                                          }
                                        />
                                      </Grid>
                                      <Grid
                                        size={{
                                          lg: 12,
                                          md: 12,
                                          sm: 12,
                                          xs: 12,
                                        }}
                                      >
                                        <CustomInput
                                          color={
                                            theme.palette.custom
                                              .productTextColor
                                          }
                                          fontSize={
                                            theme.typography.regular.fontSize
                                          }
                                          height="10px"
                                          required
                                          customLabel="Landmark"
                                          placeholder="Address"
                                          name={`items[${ind}].shop_landmark`}
                                          value={data.shop_landmark}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          error={
                                            touched?.items?.[ind]
                                              ?.shop_landmark &&
                                            Boolean(
                                              errors?.items?.[ind]
                                                ?.shop_landmark
                                            )
                                          }
                                          helperText={
                                            touched?.items?.[ind]
                                              ?.shop_landmark &&
                                            errors?.items?.[ind]?.shop_landmark
                                          }
                                        />
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                              </>
                            </Box>
                            {values?.items?.length - 1 === ind && (
                              <>
                                <StyledBoxButton>
                                  <CustomButton
                                    padding="10px 18px"
                                    fontSize={theme.typography.base.fontSize}
                                    startIcon={<AddRound />}
                                    btntype="white"
                                    color={theme.palette.custom.warning}
                                    border="1px solid #FF8500"
                                    btnLabel="Add Another Item"
                                    onClick={() => {
                                      push(
                                        values?.fieldType === "self_drop"
                                          ? selfDropItems?.[0]
                                          : values?.fieldType ===
                                            "personal_shopper"
                                          ? personalShopperItems?.[0]
                                          : shoppingItems?.[0]
                                      );
                                    }}
                                  />
                                </StyledBoxButton>

                                <StyledBoxWrapperButton>
                                  <CustomButton
                                    type="button"
                                    padding="12px 80px"
                                    fontSize={theme.typography.base.fontSize}
                                    height="54px"
                                    btnLabel="Submit"
                                    btntype={"primary"}
                                    color={theme.palette.custom.white}
                                    fontWeight={
                                      theme.typography.fontWeight.medium
                                    }
                                    border={theme.borders.defaultButton}
                                    onClick={handleSubmit}
                                  />
                                </StyledBoxWrapperButton>
                              </>
                            )}
                            {values?.items?.length - 1 !== ind && (
                              <StyledDivider />
                            )}
                          </Box>
                          {values?.items?.length - 1 !== ind && <Divider />}
                        </React.Fragment>
                      );
                    })}
                  </StyledMain>
                )}
              </FieldArray>
            </Form>
          )}
        </Formik>
      </StyledBox>
    </Modal>
  );
}
